const { Entity } = require('./entity')
const { removeNonQboSupportedChars } = require('./utils')

class JournalEntry extends Entity {
  constructor (quickbooks, query) {
    super(quickbooks, 'JournalEntry')
    this.query = query
  }

  async getByDocNumber (docNumber, companyCode) {
    if (!docNumber) {
      return null
    }

    const parsedDocNumber = removeNonQboSupportedChars(docNumber).replace(/'/g, '\\\'')
    const [response] = await this.query.send({
      companyCode,
      type: 'JournalEntry',
      where: `DocNumber = '${parsedDocNumber}'`,
      maxResults: 1
    })
    return response
  }
}

module.exports = { JournalEntry }
